import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useCancelWorkOrder(callbacks?: QueryCallbacks<void>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["cancelWorkOrder"],
    async (workorderId: number) => apiContext.workOrderApis.cancelWorkorder(workorderId),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
